module.exports = __webpack_public_path__ + "img/bubble1.2ba37a35.svg";